import { render } from "./GlobalMatch.vue?vue&type=template&id=b3dedae2"
import script from "./GlobalMatch.vue?vue&type=script&lang=js"
export * from "./GlobalMatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__